import { faChevronDown } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { IonItem, IonLabel } from '@ionic/react';
import currency from 'currency.js';
import React from 'react';
import { useContextTranslation } from 'ui/translation';
import currencyFormat from 'ui/utils/currencyFormat';

interface AvailableValue {
  value: currency;
  type: 'massage' | 'value' | 'couple_massage';
}

const AVAILABLE_VALUES: AvailableValue[] = [
  {
    value: currency(25),
    type: 'value',
  },
  {
    value: currency(50),
    type: 'value',
  },
  {
    value: currency(75),
    type: 'value',
  },
  {
    value: currency(100),
    type: 'value',
  },
  {
    value: currency(200),
    type: 'value',
  },
];

const VoucherValueSelector: React.FC<{
  expanded: boolean;
  shouldDisplaySelectedValue: boolean;
  selectedValue?: currency;
  onSelect: (selected: currency) => void;
  expandSection: () => void;
}> = ({
  expanded,
  shouldDisplaySelectedValue,
  selectedValue,
  onSelect,
  expandSection,
}) => {
  const t = useContextTranslation('page.voucher');
  const formatValue = ({ value, type }: AvailableValue) =>
    t(`voucher_amount_as_${type}`, { value: currencyFormat(value) });
  const selectedAvailableValue = AVAILABLE_VALUES.find(
    av => av.value === selectedValue,
  );

  return (
    <section className={`button-selector ${expanded ? 'expanded' : ''}`}>
      <button
        type="button"
        className={`expand-button${
          shouldDisplaySelectedValue ? ' selected' : ''
        }`}
        onClick={expandSection}
      >
        <div className="text-container">
          {selectedAvailableValue
            ? formatValue(selectedAvailableValue)
            : t('voucher_value_select')}
        </div>
        <div className="arrow-container">
          <FontAwesomeIcon icon={faChevronDown} />
        </div>
      </button>
      <div className="selectable-container">
        {AVAILABLE_VALUES.map(availableValue => {
          const { value } = availableValue;
          return (
            <IonItem
              className="voucher-value-item"
              color={
                selectedValue?.intValue === value.intValue ? 'primary' : 'light'
              }
              key={value.intValue}
              onClick={() => onSelect(value)}
              lines="none"
            >
              <IonLabel
                color={
                  selectedValue?.intValue === value.intValue
                    ? 'light'
                    : 'primary'
                }
              >
                {formatValue(availableValue)}
              </IonLabel>
            </IonItem>
          );
        })}
      </div>
    </section>
  );
};

export default VoucherValueSelector;
